(function () {
  'use strict';

  function applyIntroStyles(scope) {
    var root = scope || document;
    var intros = root.querySelectorAll('[data-intro-style-root]');

    intros.forEach(function (intro) {
      var align = intro.dataset.introAlign || '';
      var alignLast = intro.dataset.introAlignLast || '';
      var fontFamily = intro.dataset.introFontFamily || '';
      var fontWeight = intro.dataset.introFontWeight || '';
      var descendants = intro.querySelectorAll('*');

      if (align) {
        intro.style.setProperty('text-align', align, 'important');
      }

      if (alignLast) {
        intro.style.setProperty('text-align-last', alignLast, 'important');
      }

      if (fontFamily) {
        intro.style.setProperty('font-family', fontFamily, 'important');
      }

      if (fontWeight) {
        intro.style.setProperty('font-weight', fontWeight, 'important');
      }

      descendants.forEach(function (node) {
        if (align) {
          node.style.setProperty('text-align', align, 'important');
        }

        if (alignLast) {
          node.style.setProperty('text-align-last', alignLast, 'important');
        }

        if (fontFamily) {
          node.style.setProperty('font-family', fontFamily, 'important');
        }

        if (fontWeight) {
          node.style.setProperty('font-weight', fontWeight, 'important');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      applyIntroStyles(document);
    });
  } else {
    applyIntroStyles(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    applyIntroStyles(event.target);
  });
})();
